var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"api-key":_vm.tinymceAPIKEY,"init":_vm.initEditor,"value":_vm.value},on:{"onActivate":_vm.handlerFunction,"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }